"use client";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  LOGGED_IN_CATEGORY_PAGE_PAGE_SIZE,
  LOGGED_IN_FULL_WIDTH_CATEGORY_PAGE_PAGE_SIZE,
  LOGGED_IN_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE,
  LOGGED_IN_FULL_WIDTH_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE,
} from "@faire/deprecated-retailer-visitor-shared/app/_lib/templates/head/prefetches/__internal__/catNavPrefetches/consts";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useFilterablePaginatedSectionQuery } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { useSettingEnableVisualNavUpgrade } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableVisualNavUpgrade";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useBrowseLayoutQuery } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseLayoutQuery";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useIsFullWidthCategory } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";
import { useCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import { IGetSDUIFilteredComponentsRequest } from "@faire/web-api--source/indigofair/data/IGetSDUIFilteredComponentsRequest";
import { IPageIdentifier } from "@faire/web-api--source/indigofair/data/IPageIdentifier";
import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";

export const SDUICategoryPagePrefetcher = () => {
  const navigationPath = useCurrentNavigationPath();
  const isFullWidthCategory = useIsFullWidthCategory();
  const isVisualNavUpgrade = useSettingEnableVisualNavUpgrade();

  useBrowseLayoutQuery(ViewLayoutPlacement.TOP);
  useBrowseLayoutQuery(ViewLayoutPlacement.FPS);
  const pageSize = getPageSize(isFullWidthCategory, isVisualNavUpgrade);

  const filterablePaginatedSection = IFilterablePaginatedSection.build({
    get_s_d_u_i_filtered_components: IGetSDUIFilteredComponentsRequest.build({
      page_identifier: IPageIdentifier.build({
        category_page: { navigation_path: navigationPath },
      }),
      pagination_data: { page_number: 1, page_size: pageSize },
    }),
    get_s_d_u_i_navigation_tree_request: { navigation_path: navigationPath },
  });
  useFilterablePaginatedSectionQuery(filterablePaginatedSection);
  return null;
};

const getPageSize = (
  isFullWidthCategory: boolean,
  isVisualNavUpgrade: boolean
) => {
  if (isFullWidthCategory && isVisualNavUpgrade) {
    return LOGGED_IN_FULL_WIDTH_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE;
  } else if (isFullWidthCategory && !isVisualNavUpgrade) {
    return LOGGED_IN_FULL_WIDTH_CATEGORY_PAGE_PAGE_SIZE;
  } else if (!isFullWidthCategory && isVisualNavUpgrade) {
    return LOGGED_IN_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE;
  }

  return LOGGED_IN_CATEGORY_PAGE_PAGE_SIZE;
};
